var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.getMemes
    ? _c("div", { ref: "socialfeed", staticClass: "grid" }, [
        _vm._v("Getting Social Feed...")
      ])
    : _c("div", [
        _c(
          "div",
          { staticClass: "grid card__cards-wrapper" },
          _vm._l(_vm.memesToShow, function(index) {
            return _vm.memes[index]
              ? _c("div", { key: index, staticClass: "card__wrapper" }, [
                  _vm.memes[index].mediaUrl
                    ? _c("div", { staticClass: "card__image--large" }, [
                        _c("img", {
                          staticClass: "card__image",
                          attrs: {
                            alt: "",
                            src: _vm.generateMediaUrl(_vm.memes[index].mediaUrl)
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__body" }, [
                    _c("div", { staticClass: "card__label" }, [
                      _vm._v(_vm._s(_vm.memes[index].displayName))
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "card__copy",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.truncateText(_vm.memes[index].text, 100)
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "cta__standard",
                        attrs: {
                          href: _vm.memes[index].link,
                          rel: "noreferrer noopener",
                          target: "_blank"
                        }
                      },
                      [
                        _c("span", { staticClass: "cta__copy" }, [
                          _vm._v("Visit Post")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "cta__arrow cta__arrow--external" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "arrow-icon",
                                attrs: {
                                  viewBox: "0 0 13.75 12.16",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xlink:href":
                                      "/o/udliferay-theme/images/symbols/arrow-icon.svg#arrow-icon"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          }),
          0
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-918c814a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-918c814a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialFeed.vue
// module id = null
// module chunks = 